/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { ui } from '../../plugins'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('Service worker is active.')
      ui.closeNotifications()
    },
    registered (registration) {
      console.log('Service worker has been registered.')

      setInterval(() => {
        console.log('Running service worker update (1 hour interval) ...')
        registration.update()
      }, 60 * 60 * 1000)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
      ui.notifyDownloadingUpdate()
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      registration.waiting.postMessage({ action: 'skipWaiting' })
      ui.notifyUpdateFound()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}